import { render } from "./AnswerBankTransform.vue?vue&type=template&id=2119e5a5&scoped=true"
import script from "./AnswerBankTransform.vue?vue&type=script&lang=js"
export * from "./AnswerBankTransform.vue?vue&type=script&lang=js"

import "./AnswerBankTransform.vue?vue&type=style&index=0&id=2119e5a5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2119e5a5"]])

export default __exports__